var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"eIMessageTagParent"}},[_c('div',{attrs:{"id":"eITime"}},[_vm._v(_vm._s(_vm.time))]),_vm._v(" "),_c('div',{attrs:{"id":"eIMoney"}},[_vm._v(_vm._s(_vm.money)+"元")])]),_vm._v(" "),_c('HR',{staticStyle:{"border":"1 dashed #987cb9"},attrs:{"width":"95%","color":"#DCDCDC","SIZE":"1"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3a98b1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/RebateView/ExchangeLog/ExchangeRecordItem.vue
// module id = null
// module chunks = 